import { Component, type ErrorInfo, type ReactNode } from 'react'
import { AppErrorPage } from '@/pages/app-error'

type Props = { children: ReactNode }
type State = { error: unknown; hasError: boolean }

/**
 * Последний рубеж: ошибки вне роутера (провайдеры, сам роутер). Ошибки
 * экранов ловит `errorElement` маршрута и перерисовывает только экран.
 */
export class RootErrorBoundary extends Component<Props, State> {
  state: State = { error: null, hasError: false }

  static getDerivedStateFromError(error: unknown): State {
    return { error, hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[root-error-boundary]', error, info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return <AppErrorPage error={this.state.error} onRetry={() => this.setState({ error: null, hasError: false })} />
    }

    return this.props.children
  }
}
